var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "form-body form-horizontal" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-4 control-label" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("purchase_order.material.show_material")
                  ) + ":"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c("single-select", {
                    attrs: {
                      checked: _vm.formMode,
                      options: _vm.modes,
                      "allow-empty": false,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.formMode,
                      callback: function($$v) {
                        _vm.formMode = $$v
                      },
                      expression: "formMode"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.formProduction, function(dateList, dateListIndex) {
          return _c("div", { key: dateList.id, staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-md-2 control-label bold" }, [
                    _vm._v("Sekcja " + _vm._s(dateListIndex + 1))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-2 pl-10 production-row-buttons" },
                    [
                      dateListIndex === _vm.formProduction.length - 1
                        ? _c("button", {
                            staticClass: "btn btn-primary fa fa-plus",
                            attrs: {
                              title: _vm._f("trans")("grid.add_record"),
                              disabled: _vm.disabled
                            },
                            on: { click: _vm.addNewFormProductionDateList }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formProduction.length > 1
                        ? _c("button", {
                            staticClass: "btn btn-danger fa fa-trash",
                            attrs: {
                              title: _vm._f("trans")("grid.remove"),
                              disabled: _vm.disabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteFormProductionDateList(
                                  dateListIndex
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._l(dateList, function(productionRow, index) {
                  return _c("purchase-order-materials-production-row", {
                    key: productionRow.id,
                    attrs: {
                      value: productionRow,
                      teams: _vm.teams,
                      brands: _vm.brands,
                      "product-categories": _vm.productCategories,
                      disabled: _vm.disabled,
                      label: index
                        ? ""
                        : _vm.trans(
                            "production_reports.production_list.production_date"
                          ) + ":",
                      "can-delete":
                        _vm.formProduction[dateListIndex].length !== 1,
                      "can-add":
                        _vm.formProduction[dateListIndex].length === index + 1
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateFormProductionRow(
                          dateListIndex,
                          index,
                          $event
                        )
                      },
                      add: function($event) {
                        return _vm.addNewFormProductionRow(dateListIndex)
                      },
                      delete: function($event) {
                        return _vm.deleteFormProductionRow(dateListIndex, index)
                      }
                    }
                  })
                })
              ],
              2
            )
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-4 control-label" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-warning",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function($event) {
                        return _vm.search(true)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm._f("trans")(
                            "purchase_order.material.purchase_forecast"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function($event) {
                        return _vm.search(false)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm._f("trans")("purchase_order.material.search")
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function($event) {
                        return _vm.downloadXlsx(true)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm._f("trans")(
                            "purchase_order.material.download_xlsx_file"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-786a445b", { render: render, staticRenderFns: staticRenderFns })
  }
}